import { sharpDateFormatter } from 'utils/formatters';
import { defaultDatetimeFormat } from 'utils/consts';

type DataTimeProps = { value: string | null | undefined; format?: string | null | undefined };

const DataTimeText = ({ value, format }: DataTimeProps) => {
    return <>{sharpDateFormatter(value, format || defaultDatetimeFormat)}</>;
};

export default DataTimeText;
